import { useDispatch } from 'react-redux';
import { setEventWindowData } from '../../../Redux/store';
import EventRow from './EventRow';

/**
 * DayRow - Handles border, sizing, and click interactions for calendar day items
 * Decides what to display based on data type (event or prediction)
 * Handles clicks internally based on type
 * 
 * Props:
 *   data: { day, eventData } or { day, predictionData }
 */
function DayRow({ data }) {
  const dispatch = useDispatch();
  const { day, eventData, predictionData } = data;

  const handleClick = (e) => {
    e.stopPropagation();
    if (eventData) {
      dispatch(setEventWindowData({ day, eventData }));
    } else if (predictionData) {
      dispatch(setEventWindowData({ day, predictionData }));
    }
  };

  // Determine border color based on data type
  const borderColor = eventData ? 'border-blue-500' : 'border-purple-500';

  return (
    <div
      onClick={handleClick}
      className={`flex items-center gap-0.5 rounded-md border ${borderColor} bg-card p-0 hover:bg-secondary/50 cursor-pointer transition-colors`}
    >
      <EventRow eventData={eventData} predictionData={predictionData} size="xs" />
    </div>
  );
}

export default DayRow;
